import React from "react";
import Typography from "@mui/material/Typography";

const BulkUploadMarqueeComponent = () => {
  const marqueeMessage =
    "Use BBALLOC file upload only in case of contingency scenarios.";
  return (
    <div className="marqueeDisplay marqueeDisplayD1D2">
      <Typography>{marqueeMessage}</Typography>
    </div>
  );
};

export default BulkUploadMarqueeComponent;
